<template>
  <div class="headerBuyRecognition">
    <h1>Reserva de Estrellas</h1>

    <div v-if="loadingCode" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
    </div>

    <div v-else>
      <v-container>
      <v-row no-gutters>
        <v-col md="3" sm="6" class="pa-2" v-for="(item, i) in cards" :key="i">
          <v-card class="cardStyle">
            <div class="d-flex flex-no-wrap justify-space-around">
              <div>
                <v-card-title>{{ item.categoryName }}</v-card-title>
                <v-card-title class="text-h5">{{
                  item.shapeCount
                }}</v-card-title>
              </div>
              <v-avatar class="avatarStyle" size="60">
                <div class="icon-item">
                  <img :src="item.icon" />
                </div>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="table"
      item-key="categoryName"
      :custom-selectable="true"
      show-select
    >
      <template v-slot:[`item.categoryName`]="{ item }">
        <span class="custom-font">{{ item.categoryName }}</span>
      </template>
      <template v-slot:[`item.unitPrice`]="{ item }">
        <span class="custom-font">{{ formatMoney(item.unitPrice) }}</span>
      </template>

      <template v-slot:[`item.cantidad`]="{ item }">
        <span class="custom-font">
          <input :class="[
            'inputCantidad',
            { 'inputCantidad-disabled': !isSelected(item) },
          ]" :disabled="!isSelected(item)" placeholder="0" type="number" min="0" v-model.number="item.cantidad"
            @input="calculatorSubtotal($event, item)" />
        </span>
      </template>

      <template v-slot:[`item.subtotal`]="{ item }">
        <span class="custom-font" v-if="!item.cantidad || selected.length == 0">{{ formatMoney(0) }}</span>
        <span class="custom-font" v-else>{{ item.subtotalFormatted }}</span>
      </template>
    </v-data-table>
    <p class="subtotal" v-if="selected.length == 0">
      Subtotal: {{ formatMoney(0) }}
    </p>
    <p class="subtotal" v-else>
      Subtotal: {{ formatMoney(this.sumaSubTotal) }}
    </p>

    </div>


    <v-dialog
      v-model="dialog"
      transition="dialog-top-transition"
      max-width="400"
      persistent
    >
      <v-card class="container justify-content-between align-items-center pb-8">
        <button class="close-button" @click="closeDialog()">
          <span class="small-x">X</span>
        </button>

        <v-col cols="12" md="12" sm="6">
          <img
            src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
            class="custom-img"
            alt="ImagenMarcaEmpresarial"
          />
        </v-col>

        <h2 class="custom-title mb-4">Código de confirmación</h2>

        <div v-if="showCountdown" class="countdown-container text-center mb-4">
          <span>Tiempo de validez del código</span>
          <p :style="{ color: 'black', fontWeight: 'bold' }">{{ countdownText }}</p>
        </div>

        <v-form ref="form">
          <v-text-field
            v-model="confirmationCode"
            label="Ingresa el código"
            required
            maxlength="4"
            dense
            hide-details="auto"
            counter
            @keydown="handleKeyDown"
            outlined
            @input="validateConfirmationCode"
            @change="validateConfirmationCode"
          ></v-text-field>

          <div class="mt-2 text-caption text-center">
            ¿No te llegó el código? <br />
            <span
              class="text-caption"
              @click="reenviarCodigo"
              :style="{ 
                cursor: showResendButton && !isResendButtonDisabled ? 'pointer' : 'not-allowed',
                color: showResendButton ? '#6E17A5' : 'grey',
                'font-weight': showResendButton ? 'bold' : 'normal' 
              }"
              :disabled="!showResendButton || isResendButtonDisabled"
            >
              Reenviar
            </span>
          </div>
        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="!isCodeValid" @click="confirmReservationStars"
          block
          class="mt-2 text-caption"
          style="border-radius: 20px;">
            Verificar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="dialogReason"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
      :class="{
        'disabled-btn': selected.length === 0 || sumaSubTotal === 0,
        primary: selected.length > 0 && sumaSubTotal > 0,
      }"
      @click="handleButtonClick"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="selected.length > 0 && sumaSubTotal > 0 ? on : {}"
          x-medium
          fixed
          rounded
          bottom
          right
          dark
          :class="{
            'disabled-btn': selected.length === 0 || sumaSubTotal === 0,
            primary: selected.length > 0 && sumaSubTotal > 0,
          }"
          @click="handleButtonClick"
        >
          Siguiente
        </v-btn>
      </template>
      <template>
        <v-card class="container justify-content-between align-items-center">
          <button class="close-button" @click="closeDialogReason()">
            <span class="small-x">X</span>
          </button>
          <v-col cols="12" md="12" sm="6">
            <img
              src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
              class="custom-img"
            />
          </v-col>
          <h2 class="custom-title">Objetivo de las estrellas</h2>
          <p style="text-align: center">
            Por favor, indica el destino donde se utilizarán las estrellas.
          </p>
          <v-form ref="form" v-model="isFormValid">
            <v-textarea
              v-model="reasonPurchase"
              label="Objetivo*"
              required
              :rules="[rules.required, rules.maxLength]"
              maxlength="200"
              @input="validateForm"
              counter
              outlined
            ></v-textarea>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="isFormValid" @click="submitForm">
              Continuar
            </v-btn>
            <v-btn text @click="closeDialog">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import {
  ACTION_GET_CARDS,
  ACTION_GET_TABLE,
  RECOGNITION_BUYING_M,
  GET_CARDS,
  GET_TABLE,
  ACTION_POST_SEND,
  ACTION_POST_CODE_CONFIRMATION_RESERVATION,
  GET_STATE_LOADING,
  ACTION_POST_CONFIRM_RESERVATION,
  ACTION_POST_RESEND_CODE_CONFIRMATION_RESERVATION,
  ACTION_POST_PAYMENT_SUPPORT
} from "@/views/recognition/store/types/types.js";

import { mapActions, mapGetters } from "vuex";
import EventBus from "@/utils/event_bus.js";
import Swal from "sweetalert2";

export default {
  name: "BuyRecognitionComponent",

  data: () => ({
    dialog: false,
    dialogReason: false,
    sumaSubTotal: 0,
    reasonPurchase: null,
    selected: [],
    tab: null,
    isFormValid: false,
    isCodeValid:false,
    confirmationCode: null,
    tokenTime: null,
    showCountdown: false,
    countdownText: '',
    countdownTimer: null,
    secondsRemaining: 0,
    isResendButtonDisabled: false,
    showResendButton: false,
    transactionId:null,
    rules: {
      required: (value) => !!value || "Este campo es obligatorio",
      maxLength: (value) =>
        value.length <= 200 || "Máximo 200 caracteres permitidos",
    },
    items: ["Pago"],
    headers: [
      {
        text: "Categoría",
        value: "categoryName",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
      {
        text: "Valor Unitario",
        value: "unitPrice",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
      {
        text: "Cantidad",
        value: "cantidad",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
      {
        text: "Subtotal",
        value: "subtotal",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
    ],
  }),

  async mounted() {
    await this.getCards();
    await this.getTable();
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      window.location.reload();
      this.resetData();
    },

    validateConfirmationCode() {
      this.isCodeValid = !!this.confirmationCode && this.confirmationCode.length === 4;
    },

    closeDialogReason() {
      this.dialogReason = false;
      window.location.reload();
      this.resetData();
    },

    handleKeyDown(event) {
      // Permite solo números y la tecla de borrar
      if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
          event.preventDefault();
      }
    },

    ...mapActions({
      getCards: `${RECOGNITION_BUYING_M}${ACTION_GET_CARDS}`,
      getTable: `${RECOGNITION_BUYING_M}${ACTION_GET_TABLE}`,
      postActionSend: `${RECOGNITION_BUYING_M}${ACTION_POST_SEND}`,
      sendConfirmationCode: `${RECOGNITION_BUYING_M}${ACTION_POST_CODE_CONFIRMATION_RESERVATION}`,
      resendConfirmationCode: `${RECOGNITION_BUYING_M}${ACTION_POST_RESEND_CODE_CONFIRMATION_RESERVATION}`,
      confirmReservation: `${RECOGNITION_BUYING_M}${ACTION_POST_CONFIRM_RESERVATION}`,
      postActionPaymentSupport: `${RECOGNITION_BUYING_M}${ACTION_POST_PAYMENT_SUPPORT}`,
    }),

    resetData(){
      this.dialog= false;
      this.dialogReason = false;
      this.sumaSubTotal = 0;
      this.reasonPurchase = null;
      this.selected = [];
      this.tab = null;
      this.isFormValid = false;
      this.isCodeValid = false,
      this.confirmationCode = null;
      this.transactionId = null;
    },

    handleButtonClick() {
      if (this.selected.length === 0 || this.sumaSubTotal === 0) {
        this.dialogReason = false;
      } else {
        this.dialogReason = true;
      }
    },

    async submitForm() {
      if (this.reasonPurchase === null || this.reasonPurchase.trim() === "") {
        this.dialog = false;
        Swal.fire({
          icon: "error",
          title: "Errores de validación",
          html: '<div class="swal-subtitle"><b>Este campo es obligatorio.</b></div><br>',
          confirmButtonColor: "#6E17A5",
        });
      } else {
        this.dialogReason = false;
      }

      const subTotal = parseFloat(this.sumaSubTotal).toFixed(2);
      const reasonPurchase = this.reasonPurchase;
      const detail = this.selected.map((item) => ({
        categoryId: item.recognitionCategoryId,
        amount: item.cantidad,
      }));

      const payload = {
        reasonPurchase,
        subTotal,
        detail,
      };

      const transaction = await this.postActionSend(payload);
      this.transactionId = transaction.transactionId;
      await this.sendCode();
      EventBus.$emit("send-success");
    },

    async sendCode(){
      try {
        const response = await this.sendConfirmationCode();

        const mensaje = response.message;
        this.tokenTime = response.tokenTime;
        this.startCountdown(this.tokenTime);

        await Swal.fire({
          icon: 'success',
          title: 'Código enviado',
          text: mensaje,
          confirmButtonText: 'Aceptar',
        });

        this.dialog = true;
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo enviar el código. Intenta nuevamente.',
        });
        console.error('Error al enviar código:', error);
      }
    },

    async confirmReservationStars(){

      if (this.secondsRemaining <= 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Código expirado',
          text: 'El tiempo para confirmar ha expirado. Por favor, solicita un nuevo código.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      if (this.confirmationCode === null) {
        this.closeDialog();
        Swal.fire({
          icon: "error",
          title: "Errores de validación",
          html: '<div class="swal-subtitle"><b>Este campo es obligatorio.</b></div><br>',
          confirmButtonColor: "#6E17A5",
        });
      }

      const base64Code = btoa(this.confirmationCode);
      
      try {
        const response = await this.confirmReservation(base64Code);

        if (response.status === 200) {

          this.postActionPaymentSupport(this.transactionId);

          await Swal.fire({
            icon: 'success',
            title: 'Verificación completa',
            text: "Reserva de estrellas completada con éxito",
            confirmButtonText: 'Aceptar',
          });

          // ✅ Solo cerrar después del SweetAlert
          this.closeDialog();
        }

        if (response.status === 500 && response.message && !response.isHome) {
          const mensaje = response.message;
          await Swal.fire({
            icon: 'error',
            title: 'Error de verificación',
            text: mensaje,
            confirmButtonText: 'Aceptar',
          });
          this.confirmationCode = null;
        }

        if (response.status === 500 && response.isHome) {
          const mensaje = response.message;
          await Swal.fire({
            icon: 'error',
            title: 'Error de verificación',
            text: mensaje + " Vuelve a intentarlo",
            confirmButtonText: 'Aceptar',
          });
          this.closeDialog();
        }

      } catch (err) {
        console.error("Error en confirmReservationStars:", err);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al confirmar la reserva',
          confirmButtonText: 'Aceptar',
        });
        this.closeDialog();
      }
    },


    async reenviarCodigo() {
      if (!this.showResendButton || this.isResendButtonDisabled) return;

      this.isResendButtonDisabled = true;
      this.confirmationCode = null;


      try {
        const response = await this.resendConfirmationCode();

        const mensaje = response.message;

        // 🔁 Reinicia el temporizador
        this.tokenTime = response.tokenTime;
        this.startCountdown(this.tokenTime);
        this.showResendButton = false;

        await Swal.fire({
          icon: 'success',
          title: 'Código reenviado',
          text: mensaje,
          confirmButtonText: 'Aceptar',
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo reenviar el código. Intenta nuevamente.',
        });
        console.error('Error al reenviar código:', error);
      } finally {
        // 🔐 Previene doble clic
        setTimeout(() => {
          this.isResendButtonDisabled = false;
        }, 3000);
      }
    },


    startCountdown(minutes) {
      this.secondsRemaining = minutes * 60;
      this.showCountdown = true;

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        const min = Math.floor(this.secondsRemaining / 60);
        const sec = this.secondsRemaining % 60;
        this.countdownText = `${min} min ${sec < 10 ? '0' + sec : sec} seg`;
        this.secondsRemaining--;

        if (this.secondsRemaining < 0) {
          clearInterval(this.countdownTimer);
          this.countdownText = '¡Tiempo agotado!';
          this.showResendButton = true;
        }
      }, 1000);
    },


    isSelected(item) {
      this.calculatorDeleteSubTotal(item);
      return this.selected.includes(item);
    },

    formatMoney(number) {
      return (
        "$" +
        number
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },

    calculatorSubtotal(event, item) {
      item.subtotal = item.unitPrice * event.target.value;
      this.$set(item, "subtotalFormatted", this.formatMoney(item.subtotal));
      this.calculatorAdditionSubTotal(item, event.target.value);
    },

    calculatorAdditionSubTotal(item, cantidad) {
      const existingItemIndex = this.selected.findIndex(
        (element) => element.id === item.recognitionCategoryId
      );
      if (existingItemIndex !== -1) {
        this.selected[existingItemIndex].cantidad = cantidad;
      }
      this.sumaSubTotal = this.selected.reduce((sum, element) => {
        return sum + element.unitPrice * element.cantidad;
      }, 0);
      return this.sumaSubTotal;
    },

    calculatorDeleteSubTotal(item) {
      const existingItemIndex = this.selected.findIndex(
        (element) => element.id === item.recognitionCategoryId
      );
      if (existingItemIndex !== -1) {
        this.selected[existingItemIndex].cantidad = 0;
      }

      this.selected.forEach(() => {
        this.sumaSubTotal = this.selected.reduce((sum, element) => {
          if (element.cantidad) {
            return sum + element.unitPrice * element.cantidad;
          } else {
            return sum + element.unitPrice * 0;
          }
        }, 0);
      });
      return this.sumaSubTotal;
    },

    validateForm() {
      if(!this.reasonPurchase){this.reasonPurchase = null}
      if (
        !this.reasonPurchase ||
        this.reasonPurchase.trim().length === 0
      ) {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }
    },

  },
  computed: {
    ...mapGetters({
      cards: `${RECOGNITION_BUYING_M}${GET_CARDS}`,
      table: `${RECOGNITION_BUYING_M}${GET_TABLE}`,
      loadingCode: [`${RECOGNITION_BUYING_M}${GET_STATE_LOADING}`],
    }),
  },
};
</script>

<style lang="css" scoped>
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.avatarStyle {
  background-color: white !important;
}

.icon-item {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cardStyle {
  border: 3px solid;
  border-color: #f2b37b;
  border-radius: 15px;
}

.headerBuyRecognition {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.custom-font {
  font-size: 20px;
}

.inputCantidad {
  text-align: center;
  color: #2d0049;
  border: 2px solid;
  border-radius: 10px;
  border-color: #6e17a5;
  background-color: #eadcf3;
}

.inputCantidad-disabled {
  color: #888;
  background-color: #f0f0f0;
  border-color: #ccc;
}

.subtotal {
  text-align: right;
  color: #6e17a5;
  padding: 0 60px;
  font-size: 23px;
  font-weight: 500;
}

.disabled-btn {
  background-color: #ccc !important;
  color: #fff !important;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
  text-align: center;
  font-size: 33px;
  font-weight: bolder;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.small-x {
  font-size: x-large;
  color: #6e17a5;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  .custom-font {
    font-size: 13px;
  }

  .subtotal {
    text-align: right;
    color: #6e17a5;
    margin: auto;
    padding: 45px 10px;
    font-size: 23px;
    font-weight: 500;
  }
}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  h2 {
    font-size: 2vh;
  }

  .custom-font {
    font-size: 13px;
  }
}

.container {
  position: relative;
}

.v-btn.fixed {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  /* Ajusta el z-index si es necesario para asegurar que esté sobre otros elementos */
}
</style>